module.exports = __webpack_public_path__ + "img/materialScience.8942a159.png";